import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import * as Fa from "react-icons/fa";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import { Dialog } from "primereact/dialog";
import {
    createAPIEndpointServiceInvoice,
    EndpointServiceInvoice,
} from "../../Services/ServiceInvoice/ServiceInvoiceService";
import storage from "../../Services/Storage";
import InformationUrban from "./InformationUrban";
import { format, subDays } from "date-fns";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ServiceInvoice from "../ServiceInvoice/ServiceInvoice";

const UrbanServiceCreat = () => {
    const auth = storage.getLocal("user");
    const sevndate = subDays(new Date(), 7);
    const [invoiceNo, setInvoiceNo] = useState();
    const [showDialog, setShowDialog] = useState(false);
    const [afterSave, setAfterSave] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmSaveRSEPopup, setConfirmSaveRSEPopup] = useState(false);
    const [prevRSEInv, setPrevRSEInv] = useState([]);
    const [RSEName, setRSEName] = useState([]);
    const [printData, setPrintData] = useState({});

    const [supplierList, setSupplierList] = useState([]);
    const [supplierSuggestions, setSupplierSuggestions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    // const [supplierData, setSupplierData] = useState();
    const [prevRSE, setPrevRSE] = useState(false);
    const [invoiceDate, setInvoiceDate] = useState(
        new Intl.DateTimeFormat("en-GB").format(new Date()),
    );
    const [showInvoice, setShowInvoice] = useState(false);
    const [InvhId, setInvhId] = useState([]);
    const [allRecordsData, setAllRecordsData] = useState([]);
    const [showGST, setShowGST] = useState(false);
    const [supplierGstnNo, setSupplierGstnNo] = useState();
    const [searchParams] = useSearchParams();
    const invpramaId = searchParams.get("id");
    const searchItemsRSE = (e) => {
        const filtered = supplierList.filter((x) =>
            x.NAME.toLowerCase().includes(e.query.toLowerCase()),
        );
        setSupplierSuggestions(filtered);
    };

    const loadSuppliers = async () => {
        try {
            const res = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.PopulateUrbanCustomer}?UserId=${auth.UserId}&CompId=${auth.CompId}`,
            );
            setSupplierList(res.data.Data);
        } catch (err) {
            console.log(err);
        }
    };

    const handleSelectRSE = async (e) => {
        const supplier = e.value;
        setSelectedSupplier(supplier);
        setSupplierGstnNo(supplier?.GSTN_NO ?? "");

        try {
            const res = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.GetPreviousInvoice}?CompId=${auth.CompId}&SupplierId=${encodeURIComponent(supplier.MASK_SUPP_ID)}`,
            );

            if (res?.data?.Data?.length) {
                setPrevRSE(true);
                setPrevRSEInv(res.data.Data[0]);
            } else setPrevRSE(false);
        } catch (err) {
            console.log(err);
        }
    };

    const AddData = async () => {
        if (!selectedSupplier) {
            toast.warn("Please select supplier", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }

        try {
            const [sup, comp] = await Promise.all([
                createAPIEndpointServiceInvoice().get(
                    `${EndpointServiceInvoice.SupgeogId}?strSupplierId=${selectedSupplier.MASK_SUPP_ID}&ServiceType=U`,
                ),
                createAPIEndpointServiceInvoice().get(
                    `${EndpointServiceInvoice.CompgeogId}?strCompId=${auth.CompId}`,
                ),
            ]);

            setShowGST(sup.data.Data[0]?.geog_id !== comp.data.Data[0]?.geog_id);
            setShowDialog(true);
        } catch (err) {
            console.log(err);
        }
    };

    const createPayload = () => {
        const objDetl = allRecordsData.map((item) => ({
            stK_ADJ_ITM_SLNO: item.row.toString(),
            servicE_DETAIL: item.Service_Details,
            amounT_EX_GST: item.Amount_Excluding_GST.toString(),
            sutgsT_PRCNT: item.SGST_UTGST ? item.SGST_UTGST.toString() : "0",
            sutgsT_AMNT: item.SGST_UTGST_Amount.toString(),
            cgsT_PRCNT: item.CGST ? item.CGST.toString() : "0",
            cgsT_AMNT: item.CGST_Amount.toString(),
            igsT_PRCNT: item.IGST ? item.IGST.toString() : "0",
            igsT_AMNT: item.IGST_Amount.toString(),
            toT_AMNT: item.Total_Amount.toString(),
        }));
        return {
            userId: auth.UserId,
            compId: auth.CompId,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvIRPUserPassword: auth.EInvIRPUserPassword,
            eInvGSTNO: auth?.EInvGSTNO,
            invType: "U",
            cmbSupplier: selectedSupplier?.MASK_SUPP_ID,
            SuppId: selectedSupplier?.MASK_SUPP_ID,
            rdtStrtdate: format(sevndate, "dd/MM/yyyy"),
            rdtEnddate: format(new Date(), "dd/MM/yyyy"),
            objDetl: objDetl,
        };
    };

    const saveInvoice = async () => {
        setLoading(true);
        try {
            const payload = createPayload();
            console.log("Payload", payload);

            const response = await createAPIEndpointServiceInvoice().post(
                EndpointServiceInvoice.Save,
                payload,
            );

            toast.success(response?.data?.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });

            const invhId = response?.data?.SIId;
            const invoiceNo = response?.data?.SINo;

            setInvhId(invhId);
            setAfterSave(true);
            setInvoiceNo(invoiceNo);
            setRSEName(selectedSupplier?.NAME2);
            // -------- PRINT INVOICE --------

            const printPayload = {
                invhId: invhId,
                eInvApplicability: auth?.EInvApplicability,
                ServiceType: "U",
            };

            const responsePrint = await createAPIEndpointServiceInvoice().post(
                EndpointServiceInvoice.PrintServiceInv,
                printPayload,
            );

            setPrintData(responsePrint.data);
            setShowInvoice(true);
        } catch (error) {
            console.log("Error ", error);
            toast.error(error?.response?.data?.Message || "Something went wrong", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = () => {
        if (prevRSE) setConfirmSaveRSEPopup(true);
        else saveInvoice();
    };

    const onConfirm = () => {
        setConfirmSaveRSEPopup(false);
        saveInvoice();
    };
    useEffect(() => {
        if (invpramaId == null) {
            loadSuppliers();
        }
        pageload();
    }, []);

    const handleCancel = (rowData) => {
        setAllRecordsData((prevData) => {
            let updatedData;
            updatedData = prevData.filter((item) => item.row !== rowData.row);
            const adjustedData = updatedData.map((item, index) => ({
                ...item,
                row: index + 1,
            }));
            return adjustedData;
        });
    };

    const pageload = async () => {
        if (!invpramaId) return;

        try {
            const api = createAPIEndpointServiceInvoice();

            const [detailRes, invoiceRes, customerRes] = await Promise.all([
                api.get(
                    `${EndpointServiceInvoice.PopulateSIDetailData}?strInvHdrId=${invpramaId}`,
                ),
                api.get(
                    `${EndpointServiceInvoice.GetSerInvByHdrId}?SerInv_Hdr_Id=${invpramaId}`,
                ),
                api.get(
                    `${EndpointServiceInvoice.PopulateUrbanCustomer}?UserId=${auth.UserId}&CompId=${auth.CompId}`,
                ),
            ]);

            setAllRecordsData(detailRes.data.Data);

            const invoiceData = invoiceRes.data.Data?.[0];
            const suppliers = customerRes.data.Data || [];

            const supplier = suppliers.find(
                (val) => val?.MASK_SUPP_ID === invoiceData?.SUPP_ID,
            );

            if (supplier) {
                setSelectedSupplier(supplier);
                setSupplierGstnNo(supplier.GSTN_NO);

                const [supGeo, compGeo] = await Promise.all([
                    api.get(
                        `${EndpointServiceInvoice.SupgeogId}?strSupplierId=${supplier.MASK_SUPP_ID}&ServiceType=U`,
                    ),
                    api.get(
                        `${EndpointServiceInvoice.CompgeogId}?strCompId=${auth.CompId}`,
                    ),
                ]);

                setShowGST(
                    supGeo.data.Data?.[0]?.geog_id !== compGeo.data.Data?.[0]?.geog_id,
                );
                //   setShowDialog(true);
            }

            setInvoiceDate(invoiceData?.INVH_DATE);
            setInvoiceNo(invoiceData?.INVH_NO || "");
        } catch (err) {
            console.log("PageLoad Error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mx-1">
                            <li className="breadcrumb-item">
                                <Link to="/salesmanagement/urbanserviceinvoice">
                  Urban RSE Service Invoice
                                </Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                Details
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="float-end mb-2">
                        <Link to="/salesmanagement/urbanserviceinvoice">
                            <button type="submit" className="btn btn-primary">
                                <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                Records
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

            <section className="sales-box">
                <form>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                Invoice Number <span className="mandatory">*</span>
                            </label>
                            <InputText
                                className="form-control"
                                value={invoiceNo}
                                disabled
                                required
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                Invoice Date <span className="mandatory">*</span>
                            </label>
                            <InputText
                                className="form-control"
                                value={invoiceDate}
                                required
                                disabled
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                Urban RSE Name<span className="mandatory">*</span>
                            </label>
                            <AutoComplete
                                dropdown
                                value={selectedSupplier}
                                suggestions={supplierSuggestions}
                                completeMethod={searchItemsRSE}
                                field="NAME"
                                onSelect={handleSelectRSE}
                                required
                                forceSelection
                                disabled={invpramaId!=null}
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                Urban RSE GSTN Number<span className="mandatory">*</span>
                            </label>
                            <InputText
                                className="form-control"
                                value={supplierGstnNo}
                                disabled
                                required
                            />
                        </div>
                        {invpramaId == null && (
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="float-end">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary me-3"
                                        onClick={AddData}
                                        disabled={afterSave}
                                    >
                    Add Row
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={onSubmit}
                                        disabled={allRecordsData.length == 0 || afterSave}
                                    >
                    Save
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </form>
            </section>
            <section className="">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <h3>Records</h3>
                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <div className="DataTable pb-4 pt-1">
                            <DataTable
                                value={allRecordsData}
                                rows={10}
                                paginator
                                stripedRows
                                scrollable
                            >
                                <Column
                                    header="Service Details"
                                    body={(rowData) =>
                                        rowData?.Service_Details || rowData?.SERVICE_DETAIL || "-"
                                    }
                                />
                                <Column
                                    header="Amount Excluding GST"
                                    body={(rowData) =>
                                        rowData?.Amount_Excluding_GST ||
                    rowData?.AMOUNT_EX_GST ||
                    "0"
                                    }
                                />
                                {!showGST && (
                                    <Column
                                        header="SGST/ UTGST %"
                                        body={(rowData) =>
                                            rowData?.SGST_UTGST || rowData?.SUTGST_PRCNT || "0"
                                        }
                                    />
                                )}
                                {!showGST && (
                                    <Column
                                        header="SGST/ UTGST Amount"
                                        body={(rowData) =>
                                            rowData?.SGST_UTGST_Amount || rowData?.SUTGST_AMNT || "0"
                                        }
                                    />
                                )}
                                {!showGST && (
                                    <Column
                                        header="CGST %"
                                        body={(rowData) =>
                                            rowData?.CGST || rowData?.CGST_PRCNT || "0"
                                        }
                                    />
                                )}
                                {!showGST && (
                                    <Column
                                        header="CGST Amount"
                                        body={(rowData) =>
                                            rowData?.CGST_Amount || rowData?.CGST_AMNT || "0"
                                        }
                                    />
                                )}
                                {showGST && (
                                    <Column
                                        header="IGST %"
                                        body={(rowData) =>
                                            rowData?.IGST || rowData?.IGST_PRCNT || "0"
                                        }
                                    />
                                )}
                                {showGST && (
                                    <Column
                                        header="IGST Amount"
                                        body={(rowData) =>
                                            rowData?.IGST_Amount || rowData?.IGST_AMNT || "0"
                                        }
                                    />
                                )}
                                <Column
                                    header="Total Amount"
                                    body={(rowData) =>
                                        rowData?.Total_Amount || rowData?.TOT_AMNT || "0"
                                    }
                                />
                                {(invpramaId == null && !afterSave) && (
                                    <Column
                                        header="Action"
                                        body={(rowData) => {
                                            return (
                                                <i
                                                    className="pi pi-times"
                                                    style={{ color: "red", cursor: "pointer" }}
                                                    onClick={() => handleCancel(rowData)}
                                                ></i>
                                            );
                                        }}
                                    />
                                )}
                            </DataTable>
                        </div>
                    </div>
                </div>
            </section>
            <Dialog
                header="Information"
                visible={confirmSaveRSEPopup}
                style={{ width: "50vw" }}
                closable={false}
                resizable={false}
                draggable={false}
            >
                <div>
                    <p className="mb-0">
            Urban RSE Invoice with Invoice No. {prevRSEInv?.INVH_NO} dated{" "}
                        {prevRSEInv?.INVH_DATE} already exist. Are you sure you want to
            continue?
                    </p>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="float-end">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={() => onConfirm()}
                        >
              OK
                        </button>
                        <button
                            type="button"
                            className="btn btn-cancel-red"
                            onClick={() => {
                                setConfirmSaveRSEPopup(false);
                            }}
                        >
              Cancel
                        </button>
                    </div>
                </div>
                {loading ? <Loader /> : null}
            </Dialog>
            <ServiceInvoice
                DCpopup={showInvoice}
                setDCPopup={setShowInvoice}
                printData={printData}
                tag="U"
                invhid={InvhId}
                strType="U"
                rseName={RSEName}
            />
            {showDialog && (
                <InformationUrban
                    showDialog={showDialog}
                    setShowDialog={setShowDialog}
                    showGST={showGST}
                    allRecordsData={allRecordsData}
                    setAllRecordsData={setAllRecordsData}
                />
            )}
        </div>
    );
};

export default UrbanServiceCreat;
